import { environmentHttpClient } from "client/Api/httpClient";
import { ListLocationModel } from "client/Api/Documents/SharePoint/common";

export type FailedToCreateDraft = {
	message: string;
};

export type SuccessfullyCreatedDraft = {
	draftId: string;
};

export type DraftWithLinkRequestModel = {
	url: string;
};

export type DraftWithAttachedWebDavFileRequestModel = {
	serverId: number;
	fileId: string;
};

export type DraftWithAttachedSharePointFileRequestModel = {
	fileId: number;
	location: ListLocationModel;
};

export function draftWithAttachedWebDavFile(
	model: DraftWithAttachedWebDavFileRequestModel,
	signal?: AbortSignal
): Promise<SuccessfullyCreatedDraft> {
	return environmentHttpClient.post<SuccessfullyCreatedDraft>(
		"/Email/SendFile/DraftWithAttachedWebDavFile",
		model,
		{ signal }
	);
}

export function draftWithAttachedSharePointFile(
	model: DraftWithAttachedSharePointFileRequestModel,
	signal?: AbortSignal
): Promise<SuccessfullyCreatedDraft> {
	return environmentHttpClient.post<SuccessfullyCreatedDraft>(
		"/Email/SendFile/DraftWithAttachedSharePointFile",
		model,
		{ signal }
	);
}

export function draftWithLink(
	model: DraftWithLinkRequestModel,
	signal?: AbortSignal
): Promise<SuccessfullyCreatedDraft> {
	return environmentHttpClient.post<SuccessfullyCreatedDraft>(
		"/Email/SendFile/DraftWithLink",
		model,
		{ signal }
	);
}